<template>
  <div>
    <div v-if="shipping.fields_revision === true && shipping.fields_revision_data[checkpoint] && !shipping.fields_revision_data.budget_id && shipping.fields_revision_data">
      <b-alert variant="danger" show v-if="shipping.fields_revision_data[checkpoint] && typeof shipping.fields_revision_data[checkpoint] === 'string'">
        <h3 v-translate>Address not recognized</h3>
        <p v-translate>The address we have received into our system couldn't be recognized.</p>
        <p v-translate v-if="withEdit && addressEditionAllowed">Please, click on Edit Data and use the autocomplete input to search for the right street and number</p>
      </b-alert>
      <b-alert variant="warning" show v-if="shipping.fields_revision_data[checkpoint] && typeof shipping.fields_revision_data[checkpoint] === 'object'">
        <h3 v-translate>Multiple possible addresses</h3>
        <p v-translate>The address we have received into our system could refer to more than one place.</p>
        <p v-translate v-if="withEdit && addressEditionAllowed">Please, click on Edit Data and select or type the right address</p>
      </b-alert>
    </div>
    <p class="text-warning mb-3" v-if="withEdit && !addressEditionAllowed" v-translate="{companyName: shipping.company.name}">
      The destination data cannot be updated or changed here. You must contact %{companyName} and they should change it for you.
    </p>
    <h5 class="shipping-contact">
      <b-button v-if="withEdit && isEditable && !bigEditButton" variant="link" size="sm" class="px-0" v-b-modal="'modalEdit_' + checkpoint + '_' + shipping.id" @click="shippingEdit = shipping"><font-awesome-icon icon="edit" /></b-button>
      {{shipping[checkpoint + '_contact']}}
    </h5>
    <div>
      <span v-if="(!shipping.fields_revision || shipping.fields_revision === false) || !shipping.fields_revision_data[checkpoint] || typeof shipping.fields_revision_data[checkpoint] === 'object'" class="shipping-address">
        <span
          class="shipping-address"
          :class="shipping.fields_revision_data &&
            shipping.fields_revision_data[checkpoint] &&
            typeof shipping.fields_revision_data[checkpoint] === 'object' ? 'text-warning' : ''"
          :title="shipping['address_' + checkpoint].formatted_address"
          v-b-tooltip.hover>
          <font-awesome-icon v-if="shipping.fields_revision_data &&
            shipping.fields_revision_data[checkpoint] &&
            typeof shipping.fields_revision_data[checkpoint] === 'object'" icon="exclamation-triangle" size="1x" />
          <b-button size="sm" @click.stop="openMapOn(shipping['address_' + checkpoint].formatted_address + '/@' + shipping['address_' + checkpoint].lat + ',' + shipping['address_' + checkpoint].lng + ',17z')" class="py-0 px-1" :title="$gettext('Quick view address map on new window')">
            <font-awesome-icon :icon="['fa', 'map-marked-alt']" size="2x" style="font-size: 10px; vertical-align: middle;" />
          </b-button>
          {{shipping['address_' + checkpoint].formatted_address}}
        </span>
      </span>
      <span v-if="shipping.fields_revision_data !== null && typeof shipping.fields_revision_data[checkpoint] === 'string'">
        <span
          class="shipping-address text-danger"
          :title="shipping.fields_revision_data[checkpoint]"
          v-b-tooltip.hover>
          <font-awesome-icon icon="exclamation-triangle" size="1x" /> {{shipping.fields_revision_data[checkpoint]}}
        </span>
      </span>
      <div v-if="!withIcons">
        <div v-translate="{extra: shipping[checkpoint + '_extra'] || '-'}">
          Floor, door, etc.: <strong>%{extra}</strong>
        </div>
        <div v-if="checkpoint !== 'from' || shipping.company" v-translate="{email: shipping[checkpoint + '_email'] || '-'}">
          Email: <strong>%{email}</strong>
        </div>
        <div v-if="checkpoint !== 'from' || shipping.company" v-translate="{phone: shipping[checkpoint + '_phone'] ? $options.filters.phone(shipping[checkpoint + '_phone']) : '-'}">
          Phone: <strong>%{phone}</strong>
        </div>
      </div>
      <div v-else>
        <div v-if="shipping[checkpoint + '_extra'] && shipping[checkpoint + '_extra'] !== ' '">
          <font-awesome-icon size="1x" icon="crosshairs" color="dark" />
          {{shipping[checkpoint + '_extra']}}
        </div>
        <div v-if="shipping[checkpoint + '_email']">
          <font-awesome-icon size="1x" icon="envelope" color="dark" />
          {{shipping[checkpoint + '_email']}}
        </div>
        <div v-if="shipping[checkpoint + '_phone']">
          <font-awesome-icon size="1x" icon="phone" color="dark" />
          {{shipping[checkpoint + '_phone'] | phone}}
        </div>
      </div>
      <div v-if="withInstructions">
        <hr>
        <h6 v-translate>Instructions</h6>
        <div v-html="$options.filters.brize(shipping[checkpoint + '_meta'] || '-')" style="height: auto; max-height: 90px; overflow-y: auto;"></div>
      </div>
      <div v-if="withEdit && isEditable && bigEditButton">
        <hr>
        <b-button size="sm" v-b-modal="'modalEdit_' + checkpoint + '_' + shipping.id" @click="shippingEdit = shipping">
          <font-awesome-icon icon="edit" />
          <translate>Edit Data</translate>
        </b-button>
      </div>
    </div>
    <b-modal size="lg" :id="'modalEdit_' + checkpoint + '_' + shipping.id" :ref="'modalEdit_' + checkpoint + '_' + shipping.id" hide-footer @hide="shippingEdit = {}">
      <template #modal-title>
        <translate v-if="checkpoint === 'from'">Edit Origin Information</translate>
        <translate v-if="checkpoint === 'to'">Edit Destination Information</translate>
      </template>
      <template #modal-header-close><img src="@/assets/img/ic_close.svg" alt="×" /></template>
      <shipping-checkpoint-form :checkpoint="checkpoint" :shipping="shippingEdit" @success="emitUpdated(); $refs['modalEdit_' + checkpoint + '_' + shipping.id].hide();" @cancel="$refs['modalEdit_' + checkpoint + '_' + shipping.id].hide();" />
    </b-modal>
  </div>
</template>

<script>
import ShippingCheckpointForm from '@/components/ShippingCheckpointForm'

export default {
  name: 'ShippingCheckpoint',
  components: {
    ShippingCheckpointForm
  },
  props: {
    shipping: {
      type: Object,
      default: () => {},
      required: true
    },
    checkpoint: {
      type: String,
      default: 'to'
    },
    withInstructions: {
      type: Boolean,
      default: false
    },
    withEdit: {
      type: Boolean,
      default: false
    },
    withIcons: {
      type: Boolean,
      default: false
    },
    bigEditButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      shippingEdit: {}
    }
  },
  computed: {
    isEditable() {
      return this.addressEditionAllowed &&
        this.hasEditableStatus
    },
    hasEditableStatus() {
      return this.shipping.status !== 'DELIVERED' &&
        this.shipping.status !== 'CANCELED' &&
        this.shipping.status !== 'RETURNED'
    },
    addressEditionAllowed() {
      return this.shipping.company.settings &&
        this.shipping.company.settings.findIndex(x => x.name === 'guest_address_edition_disabled' && x.pivot.value === '1') === -1
    }
  },
  methods: {
    emitUpdated() {
      this.$emit('updated', true)
    }
  }
}
</script>
